import { Box, forwardRef } from '@chakra-ui/react'

type ScrollContainerProps = {
  children: React.ReactNode | React.ReactNode[]
  borderRadius?: number
  margin?: number
}

const ScrollContainer = forwardRef<ScrollContainerProps, 'div'>(
  ({ children, margin, borderRadius }, ref) => {
    const spacing = margin || 0

    return (
      <Box
        overflowX="auto"
        borderRadius={borderRadius}
        w={`calc(100% + ${8 * spacing}px)`}
        boxSizing="border-box"
        ref={ref}
        ml={-spacing}
        pl={spacing}
        pr={spacing}
      >
        {children}
      </Box>
    )
  }
)

export default ScrollContainer
